export default (BroadcasterIds: string) => {
    const allowedIds = [1679, 9, 1067]; // uploading raw materials allowed for "Channel 9", "HALA TV" and "JumboBroadcaster" clients

    if (!BroadcasterIds) return false;

    const ids = BroadcasterIds.split(',');

    return ids.some(value => allowedIds.some(allowedValue => +value === allowedValue));
};